var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"external-schedule"},[_c('external-calendar',{attrs:{"year":_vm.year,"month":_vm.month,"dates":_vm.dates,"physician":_vm.physician,"practice":_vm.practice}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }